import { createContext, useState } from 'react';

export const CurrentShow = createContext(null);

export const CurrentShowContext = ({ children }) => {
    const [showId, setShowId] = useState('');

    return <CurrentShow.Provider value={{ showId, setShowId }}>{children}</CurrentShow.Provider>;
};
